import React, {  Component } from 'react';
import { connect } from 'react-redux';

class OrderStatusOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('OrderStatusOverlayDialog');
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                    <div className="overlayDialogWindow" style={{width: '44em'}}>
                    <a className="closeButton" onClick={this.closeDialog.bind(this)} href="">×</a>
                    <h2 className="title">Order Status</h2>
					<table style={{width: '100%'}}>
						<thead>
							<tr>
								<th style={{width: '6em'}}>DIRECT</th>
								<th style={{width: '6em'}}>SDS</th>
								<th></th>
							</tr>
						</thead>
						<tbody style={{verticalAlign: 'top'}}>
							{this.props.state.order.orderStatus.data.map((item, index) => {
								return <tr key={index}>
									<td>{item.directStatus}</td>
									<td>{item.sdsStatus}</td>
									<td>{item.description}</td>
								</tr>
							})}
						</tbody>
					</table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

OrderStatusOverlayDialog = connect(mapStateToProps)(OrderStatusOverlayDialog);
export default OrderStatusOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/orderStatusOverlayDialog.js